// extracted by mini-css-extract-plugin
export default {"background":"Shared_background__-jEQO","logo":"Shared_logo__og-sn"};